import { NgModule } from '@angular/core';
import { VerifyNumberFormComponent } from './verify-number-form.component';
import { CommonModule } from '@angular/common';
import { BrunoFormsModule } from '../../modules/forms/bruno-forms.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    VerifyNumberFormComponent
  ],
  exports: [
    VerifyNumberFormComponent
  ],
  imports: [
    CommonModule,
    BrunoFormsModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class VerifyNumberModule {}
